import { createSelectorCreator, defaultMemoize } from "reselect";

import getFloor from "../floor_getters/get_floor";
import { computePhotoAreaMinimapToViewer } from "../../utilities/threejs_utilities/transform_utilities/photo_area_minimap_to_viewer_transforms";

const getPhotoAreaMinimapToViewer = createSelectorCreator(
  defaultMemoize,
  (floorA, floorB) => {
    if (floorA?.bimMinimapToWorld && floorB?.bimMinimapToWorld) {
      if (floorA?.bimMinimapToWorld?.equals(floorB?.bimMinimapToWorld) && floorA?.photoAreaMinimapPixelToBimMinimapPixel?.equals(floorB?.photoAreaMinimapPixelToBimMinimapPixel)) {
        if (floorA?.offset && floorB?.offset) {
          return floorA.offset.x === floorB.offset.x && floorA.offset.y === floorB.offset.y;
        } else {
          return floorA?.offset === floorB?.offset;
        }
      } else {
        return false;
      }
    } else if (floorA?.bimMinimapToWorld || floorB?.bimMinimapToWorld) {
      return false;
    } else {
      if (floorA?.offset && floorB?.offset) {
        return floorA.offset.equals(floorB?.offset);
      } else {
        return floorA?.offset === floorB?.offset;
      }
    }
  }
)([
  getFloor
], (floor) => {
  // These assignments are solely to be explicit about the transform names (maybe the RHS should be renamed)
  const bimMinimapToOriginalBim = floor?.bimMinimapToWorld;
  const photoAreaMinimapToBimMinimap = floor?.photoAreaMinimapPixelToBimMinimapPixel;
  return computePhotoAreaMinimapToViewer(photoAreaMinimapToBimMinimap, bimMinimapToOriginalBim, floor?.offset);
});

export default getPhotoAreaMinimapToViewer;
